import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  login(data) {
    // var data = zwitCore.HTTP.json(BASE_URL + "/zw-user/login", data, false);
    return zwitCore.HTTP.json(BASE_URL + "/zw-user/login", data, false);
  },
  getCode(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/sms/sendNew", data, false);
  },
  reg(data) {
    return zwitCore.HTTP.json(BASE_URL + "/zw-user/register/user", data, false);
  },
  logOut() {
    return zwitCore.HTTP.json(BASE_URL + "/zw-user/logout");
  },
  sonLogin(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/subUser/nf/login",
      data,
      false
    );
  },
  getclause() {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/nf/termsOfUse", {}, false);
  },
  getPrivacy() {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/nf/privacyTermsOfUse",
      {},
      false
    );
  },
  repwd(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/reset/nf/userRetrievePwd",
      data,
      false
    );
  },
  getUserInfo() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-user/nf/getloginInfo", {}, false);
  },
  validateCode(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/sms/validate", data, false);
  },
  // 验证码生成
  captcha(params) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/captcha/", params, false);
  },
  // 验证码验证
  captchaVerify(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-public/captcha/verify",
      params,
      false
    );
  },
};
